/* eslint-disable */
import React from 'react'
export const guide = [
  {url: <img src={require('../../pin-white/24-06.png')} />, title: '00 تا 05'},
  {url: <img src={require('../../pin-white/06-07.png')} />, title: '06'},
  {url: <img src={require('../../pin-white/07-08.png')} />, title: '07'},
  {url: <img src={require('../../pin-white/08-09.png')} />, title: '08'},
  {url: <img src={require('../../pin-white/09-10.png')} />, title: '09'},
  {url: <img src={require('../../pin-white/10-11.png')} />, title: '10'},
  {url: <img src={require('../../pin-white/11-12.png')} />, title: '11'},
  {url: <img src={require('../../pin-white/12-13.png')} />, title: '12'},
  {url: <img src={require('../../pin-white/13-14.png')} />, title: '13'},
  {url: <img src={require('../../pin-white/14-15.png')} />, title: '14'},
  {url: <img src={require('../../pin-white/15-16.png')} />, title: '15'},
  {url: <img src={require('../../pin-white/16-17.png')} />, title: '16'},
  {url: <img src={require('../../pin-white/17-18.png')} />, title: '17'},
  {url: <img src={require('../../pin-white/18-19.png')} />, title: '18'},
  {url: <img src={require('../../pin-white/19-20.png')} />, title: '19'},
  {url: <img src={require('../../pin-white/20-21.png')} />, title: '20'},
  {url: <img src={require('../../pin-white/21-22.png')} />, title: '21'},
  {url: <img src={require('../../pin-white/22-23.png')} />, title: '22'},
  {url: <img src={require('../../pin-white/23-24.png')} />, title: '23'}
]
export const speedGuide = [
  {url: <img src={require('../../pin-white/15-16.png')} />, title: '0 تا 60'},
  {url: <img src={require('../../pin-white/17-18.png')} />, title: '60 تا 90'},
  {url: <img src={require('../../pin-white/20-21.png')} />, title: '90 تا 110'},
  {url: <img src={require('../../pin-white/24-06.png')} />, title: 'بالای 110'}
]
